exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-2b4fa9aa] {\n  color: #fff !important;\n  min-width: 140px;\n  text-align: center;\n  display: block;\n  line-height: 31px;\n  font-weight: 400;\n  max-width: 140px;\n  cursor: pointer;\n}\n[data-v-2b4fa9aa] .dropdown-menu li {\n  cursor: pointer !important;\n}\n", ""]);

// exports
